/**
 * Admin gate — `role: 'admin'` on the User document is now the sole
 * source of truth. The old email allowlist has been removed in favour
 * of the role-promotion UI at /admin/users (PUT /api/admin/users/:id/role),
 * which is protected by requireAdminStepUp on the server.
 *
 * The named export is preserved so existing imports (Navbar,
 * AdminLogin) keep working.
 */
export const APPROVED_ADMIN_EMAILS = []; // unused; kept for back-compat

export function isApprovedAdmin(user) {
  return Boolean(user && user.role === 'admin');
}
